import {baseAxios} from '../helper/axiosHelper';

export const rightService = {
    getRightsForGroup,
    getRightsForCompanyGroup,
    updateRightsForCompanyGroup,
    updateRightsForGroup
};

function getRightsForGroup(id) {

    return baseAxios.get('right/grouprights',{params: {id: id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getRightsForCompanyGroup(id) {

    return baseAxios.get('right/companygrouprights',{params: {id: id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function updateRightsForCompanyGroup(data) {

    return baseAxios.put('right/companygrouprights',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function updateRightsForGroup(data) {

    return baseAxios.put('right/grouprights',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}